import axios from 'axios'

export async function addWish ({ ...values }) {
  let data = {
    action: values.action,
    id_product: values.idProduct,
    quantity: values.quantity,
    token: static_token, // eslint-disable-line
    id_product_attribute: values.idProductAttribute
  }

  const response = await axios.get(baseDir + 'modules/blockwishlist/cart.php', { // eslint-disable-line
    params: data
  })

  return response.data.products
}



// WEBPACK FOOTER //
// ./src/api/wishList/addWish.js